/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9.5 8V8C9.91834 8 10.1275 8 10.3216 7.96122C10.709 7.8838 11.0648 7.69339 11.3441 7.41399C11.484 7.27405 11.6002 7.09969 11.8327 6.75096V6.75096C13.0325 4.95119 13.6325 4.05131 14.1114 3.81378C15.0579 3.34443 16.2061 3.69209 16.7332 4.60759C17 5.07091 17 6.15005 17 8.30832V12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.5 8H9H8.2C7.07989 8 6.51984 8 6.09202 8.21799C5.71569 8.40973 5.40973 8.71569 5.21799 9.09202C5 9.51984 5 10.0799 5 11.2V12.8C5 13.9201 5 14.4802 5.21799 14.908C5.40973 15.2843 5.71569 15.5903 6.09202 15.782C6.51984 16 7.0799 16 8.2 16H9.49167C9.91814 16 10.1314 16 10.3291 16.0403C10.7111 16.1181 11.062 16.306 11.3386 16.5806C11.4818 16.7227 11.6001 16.9002 11.8367 17.255V17.255C13.0339 19.0508 13.6325 19.9487 14.1114 20.1862C15.0579 20.6556 16.2061 20.3079 16.7332 19.3924C17 18.9291 17 17.8499 17 15.6917V12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M5 12.7998V11.1998C5 10.0797 5 9.5196 5.21799 9.09177C5.40973 8.71545 5.71569 8.40949 6.09202 8.21774C6.51984 7.99976 7.0799 7.99976 8.2 7.99976H9.49167C9.91814 7.99976 10.1314 7.99976 10.3291 7.95947C10.7111 7.88161 11.062 7.6938 11.3386 7.41915C11.4818 7.27702 11.6001 7.0996 11.8367 6.74475C13.0339 4.94896 13.6325 4.05106 14.1114 3.81353C15.0579 3.34419 16.2061 3.69185 16.7332 4.60735C17 5.07067 17 6.14981 17 8.30808V15.6914C17 17.8497 17 18.9288 16.7332 19.3922C16.2061 20.3077 15.0579 20.6553 14.1114 20.186C13.6325 19.9485 13.0339 19.0506 11.8367 17.2548C11.6001 16.8999 11.4818 16.7225 11.3386 16.5804C11.062 16.3057 10.7111 16.1179 10.3291 16.04C10.1314 15.9998 9.91814 15.9998 9.49167 15.9998H8.2C7.0799 15.9998 6.51984 15.9998 6.09202 15.7818C5.71569 15.59 5.40973 15.2841 5.21799 14.9077C5 14.4799 5 13.9199 5 12.7998Z"
				fill="currentColor"
			/>
			<path
				d="M5 12.8V11.2C5 10.0799 5 9.51984 5.21799 9.09202C5.40973 8.71569 5.71569 8.40973 6.09202 8.21799C6.51984 8 7.0799 8 8.2 8H9.49167C9.91814 8 10.1314 8 10.3291 7.95971C10.7111 7.88185 11.062 7.69405 11.3386 7.41939C11.4818 7.27726 11.6001 7.09984 11.8367 6.745C13.0339 4.9492 13.6325 4.05131 14.1114 3.81378C15.0579 3.34443 16.2061 3.69209 16.7332 4.60759C17 5.07091 17 6.15005 17 8.30832V15.6917C17 17.8499 17 18.9291 16.7332 19.3924C16.2061 20.3079 15.0579 20.6556 14.1114 20.1862C13.6325 19.9487 13.0339 19.0508 11.8367 17.255C11.6001 16.9002 11.4818 16.7227 11.3386 16.5806C11.062 16.306 10.7111 16.1181 10.3291 16.0403C10.1314 16 9.91814 16 9.49167 16H8.2C7.0799 16 6.51984 16 6.09202 15.782C5.71569 15.5903 5.40973 15.2843 5.21799 14.908C5 14.4802 5 13.9201 5 12.8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M17.75 7.03162C17.75 5.23753 17.75 4.34049 17.6 3.92722C17.0304 2.35791 15.1122 1.77711 13.7678 2.76692C13.4137 3.02758 12.9162 3.77396 11.921 5.26674C11.6452 5.68033 11.5074 5.88713 11.3522 6.06337C10.7951 6.69598 10.0284 7.10629 9.19305 7.2189C8.96031 7.25028 8.71178 7.25028 8.21471 7.25028H7.87932C6.82765 7.25028 6.30181 7.25028 5.88153 7.40597C5.19794 7.65922 4.65894 8.19822 4.4057 8.8818C4.25 9.30208 4.25 9.82792 4.25 10.8796L4.25 13.121C4.25 14.1726 4.25 14.6985 4.4057 15.1187C4.65894 15.8023 5.19794 16.3413 5.88153 16.5946C6.30181 16.7503 6.82764 16.7503 7.87932 16.7503H8.2147C8.71177 16.7503 8.96031 16.7503 9.19305 16.7816C10.0284 16.8943 10.7951 17.3046 11.3522 17.9372C11.5074 18.1134 11.6452 18.3202 11.921 18.7338C12.9162 20.2266 13.4137 20.973 13.7678 21.2336C15.1122 22.2234 17.0304 21.6426 17.6 20.0733C17.75 19.6601 17.75 18.763 17.75 16.9689V7.03162Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 9.49988V8.3082C17 6.14993 17 5.07079 16.7332 4.60747C16.2061 3.69197 15.0579 3.34431 14.1114 3.81365C13.6325 4.05118 13.0339 4.94908 11.8367 6.74487V6.74487C11.6001 7.09972 11.4818 7.27714 11.3386 7.41927C11.062 7.69392 10.7111 7.88173 10.3291 7.95959C10.1314 7.99988 9.91814 7.99988 9.49167 7.99988H8.2C7.07989 7.99988 6.51984 7.99988 6.09202 8.21786C5.71569 8.40961 5.40973 8.71557 5.21799 9.0919C5 9.51972 5 10.0798 5 11.1999V12.7999C5 13.92 5 14.48 5.21799 14.9079C5.40973 15.2842 5.71569 15.5901 6.09202 15.7819C6.51984 15.9999 7.0799 15.9999 8.2 15.9999H9.49167C9.91814 15.9999 10.1314 15.9999 10.3291 16.0402C10.7111 16.118 11.062 16.3058 11.3386 16.5805C11.4818 16.7226 11.6001 16.9 11.8367 17.2549V17.2549C13.0339 19.0507 13.6325 19.9486 14.1114 20.1861C15.0579 20.6554 16.2061 20.3078 16.7332 19.3923C17 18.929 17 17.8498 17 15.6916V14.4999"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M5 12.8V11.2C5 10.0799 5 9.51984 5.21799 9.09202C5.40973 8.71569 5.71569 8.40973 6.09202 8.21799C6.51984 8 7.0799 8 8.2 8H9.49167C9.91814 8 10.1314 8 10.3291 7.95971C10.7111 7.88185 11.062 7.69405 11.3386 7.41939C11.4818 7.27726 11.6001 7.09984 11.8367 6.745C13.0339 4.9492 13.6325 4.05131 14.1114 3.81378C15.0579 3.34443 16.2061 3.69209 16.7332 4.60759C17 5.07091 17 6.15005 17 8.30832V15.6917C17 17.8499 17 18.9291 16.7332 19.3924C16.2061 20.3079 15.0579 20.6556 14.1114 20.1862C13.6325 19.9487 13.0339 19.0508 11.8367 17.255C11.6001 16.9002 11.4818 16.7227 11.3386 16.5806C11.062 16.306 10.7111 16.1181 10.3291 16.0403C10.1314 16 9.91814 16 9.49167 16H8.2C7.0799 16 6.51984 16 6.09202 15.782C5.71569 15.5903 5.40973 15.2843 5.21799 14.908C5 14.4802 5 13.9201 5 12.8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.87932 16.75H8.2147C8.71177 16.75 8.96031 16.75 9.19305 16.7814C10.0284 16.894 10.7951 17.3043 11.3522 17.9369C11.5074 18.1132 11.6452 18.3199 11.921 18.7335C12.9162 20.2263 13.4137 20.9727 13.7678 21.2334C15.1122 22.2232 17.0304 21.6424 17.6 20.0731C17.75 19.6598 17.75 18.7627 17.75 16.9686V12H4.25V13.1207C4.25 14.1724 4.25 14.6982 4.4057 15.1185C4.65894 15.8021 5.19794 16.3411 5.88153 16.5943C6.30181 16.75 6.82764 16.75 7.87931 16.75H7.87932Z"
				fill="currentColor"
			/>
			<path
				d="M8.2147 7.25003H7.87932C6.82764 7.25003 6.30181 7.25003 5.88153 7.40573C5.19794 7.65897 4.65894 8.19797 4.4057 8.88156C4.25 9.30184 4.25 9.82767 4.25 10.8794V12L17.75 12V7.03138C17.75 5.23729 17.75 4.34024 17.6 3.92698C17.0304 2.35767 15.1122 1.77687 13.7678 2.76667C13.4137 3.02733 12.9162 3.77372 11.921 5.2665L11.921 5.26651C11.6452 5.68009 11.5074 5.88688 11.3522 6.06313C10.7951 6.69574 10.0284 7.10605 9.19305 7.21866C8.96031 7.25003 8.71177 7.25003 8.2147 7.25003Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
